require('../../assets/js/bootstrap');
require('slick-carousel');
require('slick-lightbox');


/* FontAwesome */
import fontawesome from '@fortawesome/fontawesome';
import regular from '@fortawesome/fontawesome-free-regular';
import solid from '@fortawesome/fontawesome-free-solid';
import brands from '@fortawesome/fontawesome-free-brands';

fontawesome.library.add(regular);
fontawesome.library.add(solid);
fontawesome.library.add(brands);

function loadAdBanners(el) {
    if(el.length) {
        var iterations = 0;
        el.each(function(i) {
            axios.get($(this).data('route'))
                .then((response) =>  {
                    $(this).html(response.data);

                    iterations++;

                    console.log('load ads '+ i);

                    if(iterations === el.length) {
                        console.log('load adasync');
                        var adspirit_script = document.createElement('script');
                        adspirit_script.src = '//dvs.adspirit.de/adasync.min.js';
                        document.body.appendChild(adspirit_script);

                        slickIt($('.ad-banner-slider'));
                    }
                })
                .catch((error) =>  {
                    console.log(error);
                });
        });

    }
}


function getQueryStringObject() {

    var data = {};
    var query = window.location.search.substring(1);

    if(query.length) {

        var vars = query.split("&");

        for(var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[1].length) {
                data[pair[0]] = pair[1];
            }
        }

    }

    return data;
}


function getQueryVariable(variable) {

    var query = window.location.search.substring(1);
    var vars = query.split("&");

    for(var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[1] === variable) {
            return pair[1];
        }
    }

    return null;
}

function updateQueryStringParameter(uri, key, value, title, identifier = '') {

    var url = '';
    var data = {};
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";

    if (uri.match(re)) {
        url = uri.replace(re, '$1' + key + "=" + value + '$2');
    } else {
        url = uri + separator + key + "=" + value;
    }

    data[key] = value;
    data['id'] = identifier;

    if(key === 'keysearch') {
        // remove productsearch
        re = new RegExp('productsearch' + "=.*?(&|$)", "i");
        url = url.replace(re, '');
    } else if(key === 'productsearch') {
        // remove keysearch
        re = new RegExp('keysearch' + "=.*?(&|$)", "i");
        url = url.replace(re, '');
    }

    window.history.pushState(data, title, url);

    return url;
}

function loadView(route, target, options = {}) {

    $(target).html('<div class="ajax-loader">');

    axios.post(route, options)
        .then((response) =>  {
            // console.log(response.data);
            $(target).html(response.data);
            $('[data-toggle="tooltip"]').tooltip();
        });

}

function slickIt(el) {

    el.slick({
        dots: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnFocus: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    dots: true
                }
            }
        ]
    });

    el.on("afterChange", function(event, slick, currentSlide, nextSlide) {
        // Always forward!
        slick.direction = 1;
        if (currentSlide === (slick.slideCount-1)) {
            //console.log("last slide");
            jumpBack($(this));
        }
    });
}

function jumpBack(el) {
    setTimeout(function() {
        el.slick("slickGoTo", 0);
    }, 5000);
}

function loadSearchResults(state = {}) {

    var search_keys = ['abcsearch', 'keysearch', 'productsearch'];
    var queries = getQueryStringObject();
    var el = '';
    var options = {};

    // console.log(state);

    for(var key in queries) {
        if(search_keys.includes(key)) {

            // abcsearch
            if(key === 'abcsearch') {
                el = $('[data-history-key="'+key+'"]').closest('[data-history-value="'+queries[key]+'"]');
            }

            // keysearch
            if(key === 'keysearch') {
                // el = $('[data-history-key="'+key+'"]').has($(':input[type=text]').val(queries[key]));
                el = $('[data-history-key="'+key+'"]');
                options = {searchterm: queries[key]};

                $('#rubrik-id').val('');
                $('.search-products').find(':input[name=findone-rubrik]').val('');
            }

            // productsearch
            if(key === 'productsearch') {
                el = $('[data-history-key="'+key+'"]');
                options = {rid: queries[key]};
                $('.search-companies').find(':input[name=findone-eintrag]').val('');
            }

            if(el.length) {

                var route = el.data('href') || el.attr('action');
                var target = el.data('target');

                loadView(route, target, options);

                if(key === 'abcsearch') {
                    el.focus();
                }
            }
        }

    }

}

window.onpopstate = function(event) {
    // console.log(event.state);
    // alert(`location: ${document.location}, state: ${JSON.stringify(event.state)}`)
    loadSearchResults(event.state);
}


$(document).ready(function() {

    /* Transitions Only After Page Load */
    $('body').removeClass('preload');

    /* load view */
    $('body').on('click', '[data-action=load-view]', function(e) {
        e.preventDefault();

        var el = $(this);
        var target = el.data('target');
        var route = el.data('route');
        var view = el.data('view');
        var limit = el.data('limit');
        var children = el.data('children') || [];
        var count = $(target).find(children).length;
        // var number = $(target).find(children).last();
        /*var number = $(target).find(children).sort(function(a, b) {
            return +$(a).data('number') - +$(b).data('number');
        }).last().data('number');*/
        var numbers = $(target).find(children).map(function() {
            return $(this).data('number');
        }).get();
        var max_number = Math.max.apply(Math, numbers);
        var view_number = max_number+1;
        console.log(numbers, max_number, view_number);

        axios.get(route, {
            params: {
                view: view,
                number: view_number,
                count: count,
                limit: limit
            }})
            .then((response) =>  {
                $(target).append(response.data);
            })
            .catch((error) =>  {
                console.log(error);
            });

    });

    /* remove view */
    $('body').on('click', '[data-action=remove-view]', function(e) {
        e.preventDefault();

        var el = $(this);
        var target = el.data('target');
        // var parent = el.data('parent');
        // var children = el.data('children');

        $(target).remove();
        // var el_list = $(parent).find($(children));
        // console.log(el_list);

    });

    /* Adbanners After Page Load */
    loadAdBanners($('.ad-banners-wrapper'));

    /* Slick Slider */
    $('.slider').slick({
        dots: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: false
                }
            }
        ]
    });

    /* Slick Icon-Slider */
    $('.icon-slider').slick({
        dots: false,
        arrows: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    });

    /* Slick Banner-Slider */
    $('.banner-slider').slick({
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000
    });

    /* Slick Article Teaser Slider */
    $('.article-teaser-slider').slick({
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000
    });

    /* Slick AdBanner Slider */
    /*$('.ad-banner-slider').slick({
        dots: false,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnFocus: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    dots: true
                }
            }
        ]
    });*/

    /* Slick Lightbox */
    $('.lightbox').slickLightbox({
        src: 'href',
        itemSelector: ' a',
        caption: 'caption',
        captionPosition: 'bottom'
    });


    /* Produkte & Firmen */

    loadSearchResults();

    /* load rubriken quicklicks */
    $('[data-action=load]').click(function(e) {

        e.preventDefault();

        var el = $(this);
        var route = el.data('href');
        var target = el.data('target');

        var history = el.data('history') || false;
        var history_key = el.data('history-key') || '';
        var history_value = el.data('history-value') || '';
        var history_title = el.data('history-title') || '';
        var identifier = el.attr('id');

        if(history) {
            updateQueryStringParameter(location.href, history_key, history_value, history_title, identifier);
        }

        loadView(route, target);
    });

    /* load eintraege */
    $('[data-action=search-eintraege]').submit(function(e) {

        e.preventDefault();

        var el = $(this);
        var route = el.attr('action');
        var target = el.data('target');
        var search_val = el.find(':input[type=text]').val();
        var options = {searchterm: search_val};

        var history = el.data('history') || false;
        var history_key = el.data('history-key') || '';
        var history_value = el.data('history-value') || search_val;
        var history_title = el.data('history-title') || '';
        var identifier = el.attr('id');

        if(history) {
            updateQueryStringParameter(location.href, history_key, history_value, history_title, identifier);
        }

        $('.search-products').find(':input[type=text]').val('');
        // $(target).html('<div class="ajax-loader">');

        loadView(route, target, options);

    });

    /*$('[data-action=load]').click(function(e) {
        e.preventDefault();
        var el = $(this);
        axios.post(el.data('href'), {})
            .then((response) =>  {
                // console.log(response.data);
                $(el.data('target')).html(response.data);
            });


    });*/

    /* Bestellformular */
    $('.form-group-packages label').click(function(e) {
        if($(this).children('input').prop('checked')) {
            $(this).addClass('checked');
        } else {
            $(this).removeClass('checked');
        }
    });

    /* Mobile menu */
    $('button#mobile-button').click(function(e) {
        $('nav#mobile-menu').slideToggle('fast');
    });

    /* Eintraege Rubriken Tree Toggler */
    $('body').on('click', '.btn-show-rubriken', function(e) {

        var el = $(this);

        if(!el.hasClass('active')) {

            $(el.data('target')).html('<div class="ajax-loader">');

            axios.get(el.data('route'), {})
                .then(function (response) {
                    // console.log(response);
                    $(el.data('target')).html(response.data);
                })
                .catch(function (error) {
                    console.log(error);
                });
        }

        $($(this).data('target')).slideToggle();
        $(this).toggleClass('active');

    });


    /* Polls */
    $('body').on('submit', '[data-action=poll-vote]', function(e) {
        e.preventDefault();

        var el = $(this);
        var form = e.target;
        var form_data = new FormData(form);

        axios.post(el.attr('action'), form_data)
            .then((response) =>  {
                // console.log(response.data);
                $(el.data('target')).html(response.data);
            });


    });


    /* Register participant form - invioce address fieldset toggler */
    $('#is_not_invoice_address').change(function(e) {
        if($(this).prop('checked')) {
            $('#invoice_address').removeClass('d-none');
        } else {
            $('#invoice_address').addClass('d-none');
        }
    });

    /* Register participant form - fieldset toggler */
    $('[data-action=show-fieldset]').change(function (e) {
        var trigger = $(this);
        if (trigger.prop('checked')) {
            $(trigger.data('target')).removeClass('d-none');
        } else {
            $(trigger.data('target')).addClass('d-none');
        }
    });

});


// WEBPACK FOOTER //
// ./resources/_steel/js/frontend.js